import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { LanguageProvider, useLang } from "@/context/LanguageContext";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Activities from "@/pages/Activities";
import Services from "@/pages/Services";
import Solutions from "@/pages/Solutions";
import Technologies from "@/pages/Technologies";
import Contact from "@/pages/Contact";
import Insight from "@/pages/Insight";
import Insights from "@/pages/Insights";
import News from "@/pages/News";
import NewsArticle from "@/pages/NewsArticle";
import Careers from "@/pages/Careers";
import Legal from "@/pages/Legal";
import Detail from "@/pages/Detail";

let lenis;

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    lenis = new Lenis({ lerp: 0.085, smoothWheel: true, wheelMultiplier: 0.9 });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);
  useEffect(() => { lenis?.scrollTo(0, { immediate: true }); window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Shell() {
  const { content, loading } = useLang();
  if (!content) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center" data-testid="app-loading">
        <div className="earmark animate-pulse">{loading ? "NeuriaLabs" : "Service indisponible"}</div>
      </div>
    );
  }
  return (
    <>
      <ScrollManager />
      <Nav />
      <main className="relative">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/a-propos" element={<About />} />
          <Route path="/activites" element={<Activities />} />
          <Route path="/activites/:slug" element={<Detail collection="departments" />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<Detail collection="services" />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/solutions/:slug" element={<Detail collection="sectors" />} />
          <Route path="/technologies" element={<Technologies />} />
          <Route path="/technologies/:slug" element={<Detail collection="technologies" />} />
          <Route path="/points-de-vue" element={<Insights />} />
          <Route path="/points-de-vue/:slug" element={<Insight />} />
          <Route path="/actualites" element={<News />} />
          <Route path="/actualites/:slug" element={<NewsArticle />} />
          <Route path="/carrieres" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/legal/:slug" element={<Legal />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </LanguageProvider>
  );
}
